import { isRequired } from '@cbgms/base/utils/validations'
import Input from '@cbgms/components/form/Input'
import React from 'react'
import { useTranslation } from 'react-i18next'

const General: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Input
      data-testid='input-company-name'
      label={t('Company.Name')}
      maxLength='100'
      name='Name'
      required
      validate={isRequired}
      width='4'
    />
  )
}

export default General
